export default __webpack_public_path__ + "static/media/Thaumaturge's Armbands of Imperial Assent.360905d8.jpg";